import careConfig from "@careConfig";
import dayjs from "dayjs";
import { navigate } from "raviger";
import { useTranslation } from "react-i18next";

import CareIcon from "@/CAREUI/icons/CareIcon";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

import { Avatar } from "@/components/Common/Avatar";
import { PartnersRow } from "@/components/Common/PartnersRow";
import { WelsysFooter } from "@/components/Common/WelsysFooter";

import { useAuthContext } from "@/hooks/useAuthUser";
import { usePatientSignOut } from "@/hooks/usePatientSignOut";

import { LocalStorageKeys } from "@/common/constants";

import { TokenData } from "@/types/otp/otp";

const { customLogo, mainLogo, appName } = careConfig;

export function LandingPage() {
  const { t } = useTranslation();
  const { signIn } = useAuthContext();
  const signOut = usePatientSignOut();
  const tokenData: TokenData = JSON.parse(
    localStorage.getItem(LocalStorageKeys.patientTokenKey) || "{}",
  );

  const isLoggedIn =
    tokenData.token &&
    Object.keys(tokenData).length > 0 &&
    dayjs(tokenData.createdAt).isAfter(dayjs().subtract(14, "minutes"));

  return (
    <div className="min-h-screen flex flex-col p-5">
      {isLoggedIn && (
        <header className="w-full">
          <div className="flex justify-end items-center gap-2">
            <Button
              variant="ghost"
              className="text-sm font-medium hover:bg-gray-100 px-6"
              onClick={() => navigate("/patient/home")}
            >
              {t("home")}
            </Button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Avatar name={"User"} className="size-7 rounded-full" />
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="end">
                <DropdownMenuItem className="text-xs text-gray-500">
                  <span className="font-medium">{tokenData.phoneNumber}</span>
                </DropdownMenuItem>
                <DropdownMenuItem
                  className="text-red-600 focus:text-red-600 cursor-pointer"
                  onClick={signOut}
                >
                  <CareIcon icon="l-signout" className="mr-2 size-4" />
                  {t("sign_out")}
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
          </div>
        </header>
      )}

      <main className="flex-1 flex flex-col items-center justify-center py-8">
        {(customLogo || mainLogo) && (
          <img
            src={customLogo?.dark ?? mainLogo?.dark}
            alt={appName}
            className="h-20 md:h-24 w-auto mb-6"
          />
        )}

        {!isLoggedIn && (
          <div className="mt-8 md:mt-10 w-full max-w-sm flex flex-col gap-4">
            <Button
              variant="primary"
              size="lg"
              className="w-full"
              onClick={() => signIn()}
            >
              {t("staff_login")}
            </Button>
          </div>
        )}
      </main>

      <div className="flex flex-col items-center gap-4 pb-4">
        <PartnersRow />
      </div>
      <WelsysFooter />
    </div>
  );
}
